import React from 'react'
import cx from 'classnames'
import Icon from '@/components/common/Icon'

export type Props = {
  className?: string
  onClick?: (event: React.MouseEvent<HTMLElement>) => void
  style?: React.CSSProperties
}

const SettingSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20">
    <path
      fill="#878787"
      d="M4.803 1.494c2.322-.983 5.034-.48 6.848 1.334 1.692 1.692 2.244 4.168 1.51 6.378-.052.158 5.62 5.603 5.62 5.603.292.293.292.768 0 1.06L15.87 18.78c-.293.293-.768.293-1.061 0l-5.182-5.182-.428-.427c-1.276.507-4.692.159-6.371-1.52C1.015 9.837.511 7.125 1.494 4.803c.208-.49.845-.614 1.221-.238l2.392 2.39 1.506-.342.34-1.497-2.388-2.4c-.376-.377-.252-1.014.238-1.222zM10.59 3.89C9.212 2.51 7.19 2.369 6.532 2.56l1.65 1.65.127.127c.183.182.259.446.201.697l-.54 2.37c-.064.282-.283.501-.564.565l-2.371.54c-.251.058-.697-.2-.697-.2L2.551 6.54c-.216 1.455.252 2.964 1.338 4.05 1.377 1.377 3.438 1.76 5.201 1.013.281-.12.607-.056.823.16l5.166 5.167.278.277 1.819-1.854-5.413-5.44c-.216-.216-.28-.542-.16-.823.747-1.763.364-3.824-1.013-5.201z"
    />
  </svg>
)

const EquipSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24">
    <g fill="none" fillRule="evenodd">
      <g
        stroke="#7F7F7F"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.1">
        <path d="M19.285 7.859V1.05a.523.523 0 0 0-.524-.523H5.669L2.528 3.67v19.374c0 .29.234.524.524.524h15.709c.29 0 .524-.234.524-.524v-6.283" />
        <path d="M3.575 4.717h3.142V1.575M22.527 10.81l-1.851 1.852-1.482-1.481 1.852-1.851c-.74-.741-2.366-.597-3.333.37a3.13 3.13 0 0 0-.806 3.027l-5.884 5.885a1.569 1.569 0 0 0 0 2.221 1.568 1.568 0 0 0 2.22 0l5.886-5.884a3.126 3.126 0 0 0 3.027-.807c.968-.967 1.11-2.592.37-3.332zM6.193 7.859h8.38M6.193 9.954h8.38M6.193 12.048h4.713" />
      </g>
      <path d="M0 0h24v24H0z" />
    </g>
  </svg>
)

const MaintainSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24">
    <g fill="none" fillRule="evenodd">
      <g
        stroke="#7F7F7F"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.1">
        <path d="M8.195 13.922v3.844M6.754 15.363l-1.301 1.301a.478.478 0 0 0-.141.34V18.4a.48.48 0 0 1-.302.446l-3.596 1.44a1.44 1.44 0 0 0-.907 1.337v1.427M6.754 17.285l3.072 1.317a.48.48 0 0 1 .291.44v2.567M11.078 15.363h-.39a2.841 2.841 0 0 1-1.953-.767s-1.292-1.138-1.561-1.534c-.269-.395-.421-1.564-.421-2.065v-2.84M13.96 13.922v3.844M15.401 17.285l-3.072 1.317a.481.481 0 0 0-.292.44v2.567M11.078 15.363h.39a2.84 2.84 0 0 0 1.952-.767s1.293-1.138 1.561-1.534c.269-.395.42-1.564.42-2.065v-2.84M10.117 4.794V1.43h1.92v3.363M17.323 8.157H4.832M8.675 3.833V1.911c-1.441.48-2.882 1.875-2.882 3.844v.48l-.481.48v.48M13.48 3.833V1.911c1.441.48 2.882 1.875 2.882 3.844v.48l.48.48v.48M22.22 16.15l-1.699 1.698-1.36-1.359 1.7-1.698c-.694-.693-2.154-.565-3.058.34-.657.657-.986 1.574-.598 2.557.135.34.029.73-.23.988l-2.872 2.873c-.339.337-.421.883-.141 1.272a.961.961 0 0 0 1.464.122l2.908-2.908c.259-.259.647-.365.987-.231.984.389 1.902.06 2.559-.597.904-.904 1.033-2.365.34-3.057z" />
      </g>
      <path d="M0 0h24v24H0z" />
    </g>
  </svg>
)

const MaterialSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24">
    <g fill="none" fillRule="evenodd">
      <g stroke="#7F7F7F" strokeWidth="1.1">
        <path strokeLinecap="round" d="M6.013 19.18h-3.29v3.291" />
        <path
          strokeLinecap="round"
          d="M22.533 7.367a11.351 11.351 0 0 1 1.035 4.68c.006 2.955-1.15 5.913-3.41 8.173-2.225 2.225-5.165 3.32-8.11 3.347-3.218.033-5.575-.95-7.68-2.742-.374-.316-1.646-1.646-1.646-1.646M1.563 16.73a11.351 11.351 0 0 1-1.035-4.68c-.006-2.956 1.15-5.913 3.41-8.172C6.163 1.65 9.103.558 12.048.529c3.218-.032 5.575.952 7.68 2.742.374.317 1.646 1.646 1.646 1.646"
        />
        <path strokeLinecap="round" d="M18.083 4.917h3.29V1.625" />
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M16.436 16.437l.549.548"
        />
        <path
          strokeLinejoin="round"
          d="M5.696 7.271L7.62 9.195a.548.548 0 0 0 .777 0l1.162-1.164a.547.547 0 0 0 0-.775L7.636 5.33a.55.55 0 0 1 .264-.925 4.112 4.112 0 0 1 4.896 4.926.558.558 0 0 0 .14.524l5.897 5.897c.655.656.505 1.822-.369 2.696-.873.874-2.079 1.063-2.735.407l-6.184-6.185a.558.558 0 0 0-.44-.154A4.102 4.102 0 0 1 4.77 7.536a.55.55 0 0 1 .926-.265z"
        />
      </g>
      <path d="M0 0h24v24H0z" />
    </g>
  </svg>
)

const ReportSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20">
    <path
      fill="#878787"
      d="M17.314 2c.379 0 .686.307.686.686 0 .351-.265.641-.606.68l-.08.005h-.686v11.223c0 .345-.253.63-.584.678l-.101.008-3.957-.001 1.91 1.495c.298.234.35.665.116.963-.215.275-.599.341-.891.166l-.071-.049L10 15.465l-3.05 2.39c-.275.215-.663.187-.905-.054l-.057-.064c-.216-.275-.188-.664.052-.905l.065-.058 1.908-1.495H4.057c-.344 0-.629-.253-.678-.583l-.007-.102L3.37 3.371h-.685c-.379 0-.686-.307-.686-.685 0-.352.265-.642.606-.681L2.686 2h14.628zm-2.057 1.371H4.742v9.012l1.713-2.6c.178-.27.519-.376.815-.263l.08.036 1.293.688.697-3.453c.104-.52.726-.72 1.114-.389l.062.06 1.374 1.492 1.105-1.071c.251-.244.64-.257.906-.044l.064.059c.243.25.256.64.043.905l-.058.064-1.61 1.562c-.255.248-.653.256-.918.033l-.064-.06-.94-1.022-.612 3.038c-.085.422-.528.655-.917.505l-.077-.035-1.556-.829-1.876 2.848 9.877.001V3.371z"
    />
  </svg>
)

const SystemSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20">
    <path
      fill="#878787"
      d="M15.13 9.267c.2 0 .374.134.423.325l.13.506.132.042c.13.045.256.096.379.155l.123.062.456-.268c.15-.088.337-.078.475.019l.057.047.794.783c.142.139.169.354.066.523l-.272.45.064.12c.059.122.112.246.157.374l.042.13.515.128c.172.043.298.183.324.352l.005.065v1.107c0 .197-.136.369-.33.417l-.513.128-.043.13c-.045.127-.098.252-.157.373l-.064.121.272.45c.09.147.08.331-.018.468l-.048.056-.794.783c-.141.14-.36.166-.532.065l-.457-.268-.122.062c-.123.059-.25.11-.379.155l-.132.042-.13.507c-.043.17-.186.294-.357.32L15.13 18h-1.124c-.2 0-.374-.134-.423-.325l-.13-.506-.132-.042c-.129-.045-.255-.096-.378-.155l-.124-.062-.455.268c-.15.088-.337.079-.476-.018l-.056-.047-.795-.783c-.141-.14-.168-.355-.066-.524l.272-.45-.064-.122c-.06-.121-.112-.246-.157-.373l-.043-.13-.513-.127c-.172-.043-.298-.183-.324-.352l-.005-.065V13.08c0-.197.135-.368.329-.417l.513-.128.043-.13c.046-.126.098-.25.157-.372l.064-.122-.272-.45c-.09-.147-.08-.331.018-.468l.048-.056.795-.783c.141-.139.36-.165.532-.065l.455.268.124-.062c.123-.059.25-.11.378-.155l.132-.042.13-.506c.044-.17.186-.294.357-.32l.066-.005zm-.34.859h-.445l-.108.424c-.034.134-.13.242-.258.293l-.066.02c-.308.07-.6.19-.869.356-.138.085-.313.086-.453.004l-.383-.225-.314.31.228.377c.071.119.08.262.027.387l-.032.06c-.167.265-.29.553-.36.855-.037.157-.16.28-.318.32l-.43.107v.438l.43.108c.136.034.246.13.297.255l.021.065c.07.302.193.59.36.855.087.137.088.31.005.448l-.228.376.314.31.382-.225c.12-.07.266-.08.393-.027l.061.032c.269.164.561.284.869.355.16.036.284.157.324.313l.108.424h.445l.11-.424c.034-.134.13-.242.258-.293l.066-.02c.307-.07.6-.19.868-.355.138-.086.314-.087.454-.005l.382.225.314-.31-.227-.376c-.072-.119-.081-.263-.028-.387l.032-.061c.168-.265.29-.552.36-.856.038-.156.16-.28.319-.32l.43-.107v-.438l-.43-.107c-.136-.034-.245-.129-.297-.254l-.021-.065c-.072-.303-.194-.591-.36-.855-.087-.137-.09-.31-.005-.448l.227-.377-.314-.31-.382.225c-.12.07-.266.08-.393.027l-.061-.031c-.268-.165-.56-.285-.868-.356-.16-.036-.284-.157-.324-.313l-.11-.424zM15.457 3c1.018 0 1.85.783 1.91 1.77l.003.115v3.937c0 .316-.26.573-.58.573-.297 0-.542-.219-.577-.501l-.005-.072-.001-2.49H3.162v8.177c0 .38.293.695.67.735l.081.004h5.772c.32 0 .58.257.58.573 0 .292-.22.533-.507.568l-.073.005H3.913c-1.017 0-1.85-.783-1.91-1.77L2 14.508V4.885c0-1.003.794-1.822 1.797-1.882L3.913 3h11.543zm-.888 8.785c1.037 0 1.877.827 1.877 1.849 0 1.021-.84 1.849-1.877 1.849-1.036 0-1.876-.828-1.876-1.85 0-1.02.84-1.848 1.876-1.848zm0 1.073c-.434 0-.787.347-.787.776 0 .428.353.775.787.775.435 0 .787-.347.787-.775 0-.429-.352-.776-.787-.776zm-6.971-5.87c.268.067.44.317.41.58l-.014.072-.887 3.5c-.073.287-.37.462-.661.39-.268-.066-.44-.316-.41-.58l.013-.071.888-3.5c.073-.287.37-.462.661-.39zM5.63 8.006c.194.19.211.489.053.699l-.053.06-.503.495.503.496c.194.19.211.488.053.699l-.053.06c-.193.19-.496.208-.71.052l-.06-.052-.888-.875c-.194-.19-.211-.489-.053-.7l.053-.06.888-.874c.213-.21.558-.21.77 0zm3.49-.052l.062.052.888.875c.193.19.211.489.053.699l-.053.06-.888.875c-.213.21-.558.21-.77 0-.194-.19-.212-.489-.053-.7l.052-.06.503-.495-.503-.495c-.193-.19-.21-.489-.052-.699l.052-.06c.194-.19.497-.208.71-.052zm6.336-3.808H3.913c-.387 0-.705.289-.746.66l-.005.08v.302h13.044l.001-.302c0-.381-.293-.695-.669-.735l-.082-.005z"
    />
  </svg>
)

const LinkSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24">
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h24v24H0z" />
      <g stroke="#7F7F7F" strokeLinejoin="round" strokeWidth="1.1">
        <path d="M5.906 11.455l-4.27 4.27a3.623 3.623 0 0 0 0 5.122l1.709 1.708a3.623 3.623 0 0 0 5.122 0l6.403-6.403a3.621 3.621 0 0 0 0-5.123L13.163 9.32a3.66 3.66 0 0 0-.998-.707" />
        <path d="M18.286 12.736l4.27-4.268a3.624 3.624 0 0 0 0-5.124l-1.709-1.707a3.623 3.623 0 0 0-5.122 0L9.322 8.04a3.622 3.622 0 0 0 0 5.123l1.706 1.708c.3.299.638.535.999.708M5.724 5.504L3.309 3.09M5.12 7.315H1.498M7.535 1.278V4.9M19.006 18.182l2.415 2.415M19.61 16.37h3.622M17.195 22.408v-3.622" />
      </g>
    </g>
  </svg>
)

const EditSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="24"
    height="24"
    viewBox="0 0 24 24">
    <defs>
      <path
        id="a"
        d="M14 3.414l-10 10V16h2.586l10-10L14 3.414zm.707-2.121l4 4a1 1 0 0 1 0 1.414l-11 11A1 1 0 0 1 7 18H3a1 1 0 0 1-1-1v-4a1 1 0 0 1 .293-.707l11-11a1 1 0 0 1 1.414 0zM3 23a1 1 0 0 1 0-2h18a1 1 0 0 1 0 2H3z"
      />
    </defs>
    <use fill="#4A4A4A" fillRule="nonzero" xlinkHref="#a" />
  </svg>
)

const LocationSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24">
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h24v24H0z" />
      <path
        fill="#4A4A4A"
        fillRule="nonzero"
        d="M12 5.337a4.71 4.71 0 0 0-3.347 1.385 4.701 4.701 0 0 0-1.385 3.347c0 1.265.492 2.451 1.385 3.347A4.701 4.701 0 0 0 12 14.8a4.705 4.705 0 0 0 3.347-1.385 4.701 4.701 0 0 0 1.385-3.347 4.705 4.705 0 0 0-1.385-3.347A4.71 4.71 0 0 0 12 5.337zm0 7.79a3.06 3.06 0 0 1-3.059-3.058A3.06 3.06 0 0 1 12 7.01a3.06 3.06 0 0 1 3.059 3.059A3.06 3.06 0 0 1 12 13.127zm8.405-6.808a8.216 8.216 0 0 0-2.009-2.553 9.572 9.572 0 0 0-2.916-1.715 9.913 9.913 0 0 0-3.478-.628h-.004c-1.191 0-2.36.21-3.478.628a9.572 9.572 0 0 0-2.916 1.715A8.209 8.209 0 0 0 3.595 6.32a6.995 6.995 0 0 0-.75 3.138c0 1.507.37 3.056 1.102 4.605.605 1.283 1.46 2.576 2.545 3.847 1.94 2.273 4.125 3.9 4.974 4.493a.927.927 0 0 0 1.068 0c.849-.593 3.036-2.22 4.974-4.493 1.083-1.27 1.94-2.564 2.545-3.846.731-1.55 1.102-3.101 1.102-4.606 0-1.085-.253-2.14-.75-3.138zm-.926 3.14c0 1.259-.316 2.57-.942 3.893-.537 1.144-1.313 2.311-2.302 3.471-1.544 1.812-3.274 3.197-4.235 3.903-.96-.708-2.69-2.09-4.235-3.903-.99-1.16-1.765-2.33-2.304-3.473-.626-1.324-.942-2.634-.942-3.893 0-.825.192-1.631.574-2.393A6.58 6.58 0 0 1 6.698 5.03a7.876 7.876 0 0 1 2.405-1.416 8.283 8.283 0 0 1 2.895-.523h.004c.99 0 1.964.176 2.893.523.897.335 1.706.811 2.407 1.416a6.47 6.47 0 0 1 1.603 2.034c.382.769.574 1.573.574 2.395z"
      />
    </g>
  </svg>
)

const EyeSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={24}
    height={24}
    viewBox="0 0 24 24">
    <defs>
      <path
        id="a"
        d="M22.157 11.798c-.007-.132-.209-.78-.49-1.456-.288-.696-.776-1.704-1.45-2.545a9.632 9.632 0 0 0-3.24-2.623C15.423 4.394 13.605 4 11.575 4c-2.027 0-3.846.396-5.4 1.177a9.695 9.695 0 0 0-3.24 2.62c-.674.844-1.16 1.851-1.448 2.548-.28.675-.48 1.324-.487 1.455V11.809c.007.132.209.78.49 1.458.29.696.776 1.704 1.448 2.543a9.632 9.632 0 0 0 3.24 2.623c1.563.783 3.379 1.179 5.4 1.179 2.022 0 3.838-.396 5.4-1.18a9.688 9.688 0 0 0 3.238-2.62c.675-.84 1.163-1.849 1.451-2.545.281-.675.483-1.324.49-1.455v-.005-.01zm-1.739.004c-.134.408-.652 1.88-1.51 2.949l-.011.011a8 8 0 0 1-2.679 2.17c-1.324.664-2.89 1.002-4.65 1.002-1.763 0-3.326-.338-4.65-1.001a7.963 7.963 0 0 1-2.679-2.173c-.862-1.073-1.383-2.55-1.516-2.96.133-.408.654-1.882 1.516-2.96A8.01 8.01 0 0 1 6.92 6.67c1.327-.664 2.893-.999 4.655-.999 1.77 0 3.333.335 4.648.999a7.963 7.963 0 0 1 2.679 2.172c.862 1.078 1.382 2.553 1.516 2.96zm-8.843-4.08a4.067 4.067 0 0 0-4.062 4.062 4.068 4.068 0 0 0 4.062 4.061 4.068 4.068 0 0 0 4.062-4.061 4.067 4.067 0 0 0-4.062-4.062zm2.39 4.062c0 .637-.248 1.237-.7 1.69-.453.452-1.053.7-1.69.7a2.374 2.374 0 0 1-1.69-.7 2.374 2.374 0 0 1-.7-1.69c0-.638.248-1.238.7-1.69a2.374 2.374 0 0 1 1.69-.701c.638 0 1.238.248 1.69.7.452.453.7 1.053.7 1.69z"
      />
    </defs>
    <use fill="#4A4A4A" fillRule="nonzero" xlinkHref="#a" />
  </svg>
)

const AddSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24">
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h24v24H0z" />
      <path
        fill="#4A4A4A"
        fillRule="nonzero"
        d="M20.156 18H16.5v-3.656a.843.843 0 1 0-1.688 0V18h-3.468a.843.843 0 1 0 0 1.688h3.469v3.468a.843.843 0 1 0 1.687 0v-3.468h3.656a.843.843 0 1 0 0-1.688zm.354-10.927L13.995.5a1.815 1.815 0 0 0-.347-.27 1.428 1.428 0 0 0-.103-.053c-.022-.012-.045-.021-.066-.03A1.696 1.696 0 0 0 12.797 0h-8.11C3.756 0 3 .755 3 1.688v20.625C3 23.244 3.755 24 4.688 24h4.968a.843.843 0 1 0 0-1.688H4.687V1.688H12v5.625C12 8.245 12.755 9 13.688 9h5.624v3.656a.843.843 0 1 0 1.688 0V8.262c0-.446-.176-.872-.49-1.189zm-6.823.24V2.588l4.683 4.724h-4.683z"
      />
    </g>
  </svg>
)

const ExportSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24">
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h24v24H0z" />
      <path
        fill="#4A4A4A"
        fillRule="nonzero"
        d="M18.916 13.669a.84.84 0 0 0-.839.839v4.779a.435.435 0 0 1-.436.436H4.352a.435.435 0 0 1-.436-.436V5.527c0-.242.195-.436.436-.436h5.968a.84.84 0 0 0 0-1.678H4.355a2.114 2.114 0 0 0-2.112 2.111v13.76c0 1.163.947 2.11 2.112 2.11h13.291a2.114 2.114 0 0 0 2.112-2.112v-4.774a.845.845 0 0 0-.842-.84zm-8.76-4.927c-1.008 1.524-1.254 3.021-1.278 3.188a.84.84 0 0 0 .83.958c.412 0 .769-.31.83-.712.007-.056.22-1.322 1.042-2.543 1.08-1.603 2.705-2.421 4.82-2.428.032.002.06.004.084.004a.84.84 0 0 0 .839-.839v-.986l2.355 2.24-2.358 1.964v-.801a.84.84 0 0 0-1.678 0v2.592a.842.842 0 0 0 1.374.647l4.455-3.71a.837.837 0 0 0 .298-.617.838.838 0 0 0-.258-.637l-4.453-4.24a.837.837 0 0 0-1.413.607v2.13c-2.947.246-4.61 1.861-5.49 3.183z"
      />
    </g>
  </svg>
)

const ProcessSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24">
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h24v24H0z" />
      <path
        fill="#4A4A4A"
        fillRule="nonzero"
        d="M3.809 13.688h8.882c.446 0 .809-.361.809-.81v-.07a.807.807 0 0 0-.809-.808H3.81a.809.809 0 0 0-.809.809v.07c0 .448.36.809.809.809zm8.789 1.08a.842.842 0 0 0 0 1.193l1.99 1.99.02.02.022.022.082.082a.785.785 0 0 0 1.11 0l5.25-5.255a.785.785 0 0 0 0-1.11l-.081-.083a.785.785 0 0 0-1.111 0l-4.615 4.615-1.474-1.474a.842.842 0 0 0-1.193 0zM22.312 4.5h-1.968v-.656a.843.843 0 1 0-1.688 0V4.5h-5.812v-.656a.843.843 0 1 0-1.688 0V4.5H5.344v-.656a.843.843 0 1 0-1.688 0V4.5H1.687C.755 4.5 0 5.255 0 6.188v13.125C0 20.244.755 21 1.688 21h20.625c.932 0 1.687-.755 1.687-1.688V6.188c0-.932-.755-1.687-1.688-1.687zm0 14.813H1.688V10.5h20.625v8.813zm0-10.5H1.688V6.187h1.97v.47a.843.843 0 1 0 1.687 0v-.47h5.812v.47a.843.843 0 1 0 1.688 0v-.47h5.812v.47a.843.843 0 1 0 1.688 0v-.47h1.968v2.625zM3.81 16.593H9.69c.446 0 .809-.36.809-.808v-.07a.807.807 0 0 0-.809-.809H3.81a.809.809 0 0 0-.809.809v.07c0 .448.36.809.809.809z"
      />
    </g>
  </svg>
)

const InfoSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24">
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h24v24H0z" />
      <path d="M.023 0H24v23.977H.023z" />
      <path
        fill="#4A4A4A"
        fillRule="nonzero"
        d="M22.478 9.75V6.93c0-.931-.754-1.685-1.686-1.685H11.45l-.586-1.824a1.682 1.682 0 0 0-1.606-1.173H1.686C.754 2.248 0 3.002 0 3.934V20.05a1.68 1.68 0 0 0 .021.253c.005.023.007.047.012.07l.004.019.015.058c.002.012.007.024.009.035l.007.029c.007.025.014.049.023.072v.002c.087.253.232.478.422.66l.004.005c.02.017.036.033.054.05.01.007.019.016.026.023l.026.021.047.038c.004.002.009.007.014.009l.058.042c.003 0 .003.002.005.002a1.657 1.657 0 0 0 .773.28c.025.001.049.004.075.004h.014l.077.002h18.45a1.69 1.69 0 0 0 1.637-1.276l2.154-8.617a1.689 1.689 0 0 0-1.449-2.081zM1.686 3.934h7.567l.965 2.997h10.574v2.81H3.84a1.69 1.69 0 0 0-1.637 1.276l-.517 2.079V3.934zm18.45 16.109H1.687l2.154-8.617h18.45l-2.153 8.617z"
      />
    </g>
  </svg>
)

const LightSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20">
    <path
      fill="#878787"
      d="M9.796 1c4.85 0 8.797 3.947 8.797 8.796 0 4.85-3.947 8.797-8.797 8.797C4.947 18.593 1 14.646 1 9.796 1 4.947 4.947 1 9.796 1zm0 1.466c-4.057 0-7.33 3.273-7.33 7.33s3.273 7.33 7.33 7.33 7.33-3.273 7.33-7.33-3.273-7.33-7.33-7.33zM12.65 4.86c.286-.119.604.023.754.323l.57 1.155c.1.202.112.436.034.647-.075.2-.225.35-.413.407L9.837 8.512l-.08.013-.032.001c-.11 0-.216-.037-.308-.106-.14-.105-.237-.277-.268-.467l-.065-.322-1.157.569c-.104.052-.176.189-.174.344l.096 6.635c.003.193-.129.36-.307.36h-.615c-.178 0-.31-.167-.306-.36l.1-6.882c.003-.234.12-.447.304-.54l1.94-.996c.021-.011.044-.047.059-.106l.027-.087c.064-.168.181-.3.334-.361z"
    />
  </svg>
)

const HistorySVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    viewBox="0 0 18 18">
    <defs>
      <path id="history" d="M0 0h9.41v10.955H0z" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h18v18H0z" />
      <circle cx={9} cy={9} r={8.5} stroke="#FFF" />
      <g>
        <path
          fill="#FFF"
          d="M12.11 5.4c-1.856-1.855-4.863-1.872-6.718-.018l-.56.555-.605-.605H4v2.264h2.262v-.228l-.475-.476.564-.565a3.332 3.332 0 0 1 2.4-.978 3.443 3.443 0 0 1 2.399 1.01c.704.705 1.029 1.689.983 2.592h1.358c.045-1.355-.412-2.583-1.381-3.55zM11.239 9.857v.226l.474.475-.563.55c-1.325 1.325-3.474 1.31-4.798-.016-.703-.703-1.028-1.688-.983-2.593h-1.36c-.044 1.358.414 2.584 1.383 3.553 1.854 1.856 4.862 1.871 6.718.016l.56-.555.605.606h.226V9.857h-2.262z"
        />
        <path
          stroke="#FFF"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M9.656 9.63l-.905-.904V6.691"
        />
      </g>
    </g>
  </svg>
)

const ChartSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20">
    <path
      fill="#878787"
      d="M17.314 2c.379 0 .686.307.686.686 0 .351-.265.641-.606.68l-.08.005h-.686v11.223c0 .345-.253.63-.584.678l-.101.008-3.957-.001 1.91 1.495c.298.234.35.665.116.963-.215.275-.599.341-.891.166l-.071-.049L10 15.465l-3.05 2.39c-.275.215-.663.187-.905-.054l-.057-.064c-.216-.275-.188-.664.052-.905l.065-.058 1.908-1.495H4.057c-.344 0-.629-.253-.678-.583l-.007-.102L3.37 3.371h-.685c-.379 0-.686-.307-.686-.685 0-.352.265-.642.606-.681L2.686 2h14.628zm-2.057 1.371H4.742v9.012l1.713-2.6c.178-.27.519-.376.815-.263l.08.036 1.293.688.697-3.453c.104-.52.726-.72 1.114-.389l.062.06 1.374 1.492 1.105-1.071c.251-.244.64-.257.906-.044l.064.059c.243.25.256.64.043.905l-.058.064-1.61 1.562c-.255.248-.653.256-.918.033l-.064-.06-.94-1.022-.612 3.038c-.085.422-.528.655-.917.505l-.077-.035-1.556-.829-1.876 2.848 9.877.001V3.371z"
    />
  </svg>
)

const HomeSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    viewBox="0 0 18 18">
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h18v18H0z" />
      <circle cx={9} cy={9} r={8.5} stroke="#FFF" />
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="M10.5 9.75a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1v3.75H5.85c-.746 0-1.35-.58-1.35-1.295v-4.75c0-.134.064-.26.174-.341l4.05-3.023a.465.465 0 0 1 .552 0l4.05 3.023c.11.081.174.207.174.34v4.75c0 .716-.604 1.296-1.35 1.296H10.5z"
      />
    </g>
  </svg>
)

const DashboardSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20">
    <path
      fill="#878787"
      d="M10 1c-4.962 0-9 4.038-9 9s4.038 9 9 9 9-4.038 9-9-4.038-9-9-9zm0 1.5c4.151 0 7.5 3.349 7.5 7.5s-3.349 7.5-7.5 7.5-7.5-3.349-7.5-7.5S5.849 2.5 10 2.5zm0 .75c-.414 0-.75.336-.75.75s.336.75.75.75.75-.336.75-.75-.336-.75-.75-.75zM5.758 5.008c-.414 0-.75.336-.75.75s.336.75.75.75.75-.336.75-.75-.336-.75-.75-.75zm8.522.799c-.319-.312-.827-.316-1.141-.004l-2.764 2.744c-.12-.031-.246-.047-.375-.047-.828 0-1.5.672-1.5 1.5s.672 1.5 1.5 1.5 1.5-.672 1.5-1.5c0-.13-.016-.255-.047-.375l2.764-2.764c.311-.311.314-.809-.013-1.129l.076.075zM4 9.25c-.414 0-.75.336-.75.75s.336.75.75.75.75-.336.75-.75-.336-.75-.75-.75zm12 0c-.414 0-.75.336-.75.75s.336.75.75.75.75-.336.75-.75-.336-.75-.75-.75zM5.758 13.492c-.414 0-.75.336-.75.75s.336.75.75.75.75-.336.75-.75-.336-.75-.75-.75zm8.484 0c-.414 0-.75.336-.75.75s.336.75.75.75.75-.336.75-.75-.336-.75-.75-.75z"
    />
  </svg>
)

const CheckSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24">
    <g fill="#4A4A4A" fillRule="nonzero">
      <path d="M19.923 2.165L8.666 13.853l-4.59-4.765a1.332 1.332 0 0 0-1.93 0 1.435 1.435 0 0 0 0 1.978l5.555 5.77c.532.552 1.4.552 1.931 0L21.855 4.142a1.435 1.435 0 0 0 0-1.978 1.332 1.332 0 0 0-1.932 0zM21.656 20.813H2.344a.843.843 0 1 0 0 1.687h19.312a.843.843 0 1 0 0-1.688z" />
    </g>
  </svg>
)

const UserSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20">
    <path
      fill="#878787"
      d="M16.716 2C17.424 2 18 2.577 18 3.286v6.071c0 .356-.287.643-.642.643-.355 0-.642-.287-.642-.643V3.286H3.284v13.428h4.941c.355 0 .642.288.642.643 0 .355-.287.643-.642.643h-4.94C2.575 18 2 17.423 2 16.714V3.286C2 2.576 2.576 2 3.284 2zm-2.159 8.334c1.299 0 2.355 1.057 2.355 2.357 0 .82-.42 1.541-1.054 1.964 1.068.433 1.887 1.384 2.112 2.574.066.348-.163.684-.51.751-.04.008-.08.011-.12.011-.301 0-.57-.214-.63-.523-.194-1.032-1.1-1.78-2.15-1.78-1.051 0-1.956.748-2.152 1.78-.066.35-.403.578-.75.512-.35-.066-.579-.403-.513-.751.225-1.188 1.044-2.141 2.112-2.574-.635-.423-1.054-1.146-1.054-1.964 0-1.3 1.056-2.357 2.354-2.357zm0 1.286c-.59 0-1.07.48-1.07 1.071s.48 1.071 1.07 1.071c.59 0 1.07-.48 1.07-1.07 0-.592-.48-1.072-1.07-1.072zm-6.332.666c.355 0 .642.287.642.643 0 .355-.287.642-.642.642H4.943c-.355 0-.642-.287-.642-.642 0-.356.287-.643.642-.643zm0-3.429c.355 0 .642.288.642.643 0 .355-.287.643-.642.643H4.943c-.355 0-.642-.288-.642-.643 0-.355.287-.643.642-.643zm2.283-3.428c.355 0 .643.287.643.642 0 .356-.288.643-.643.643H4.943c-.355 0-.642-.287-.642-.643 0-.355.287-.642.642-.642z"
    />
  </svg>
)

const ListAltSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    viewBox="0 0 18 18">
    <g fill="none" fillRule="evenodd">
      <path d="M0 0H18V18H0z" />
      <circle cx={9} cy={9} r={8.5} stroke="#FFF" />
      <path
        fill="#FFF"
        d="M12.676 5c.18 0 .324.153.324.324v7.352c0 .18-.153.324-.324.324H5.324c-.18 0-.324-.153-.324-.324V5.324c0-.18.153-.324.324-.324h7.352zm-1.343 5.667H6.667c-.18 0-.334.149-.334.333 0 .179.15.333.334.333h4.666c.18 0 .334-.149.334-.333l-.007-.066c-.031-.149-.166-.267-.327-.267zm0-2H6.667c-.18 0-.334.149-.334.333 0 .179.15.333.334.333h4.666c.18 0 .334-.149.334-.333l-.007-.066c-.031-.149-.166-.267-.327-.267zm0-2H6.667c-.18 0-.334.149-.334.333 0 .179.15.333.334.333h4.666c.18 0 .334-.149.334-.333l-.007-.066c-.031-.149-.166-.267-.327-.267z"
      />
    </g>
  </svg>
)

const PlaySVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24">
    <g fill="none" fillRule="evenodd" opacity=".5">
      <g>
        <g>
          <g>
            <g>
              <g>
                <g transform="translate(-1076 -281) translate(216 180) translate(0 24) translate(0 65) translate(860 12) translate(2 2)">
                  <g>
                    <path
                      d="M0 0H13.333V13.333H0z"
                      transform="translate(3.636 3.636)"
                    />
                    <g fill="#4A4A4A" fillRule="nonzero">
                      <path
                        d="M1.308.548l6.816 4.808c.263.201.263.555 0 .756l-6.816 4.83c-.382.29-.987.06-.987-.378V.924C.323.489.926.256 1.308.549z"
                        transform="translate(3.636 3.636) translate(3.03 .606)"
                      />
                    </g>
                  </g>
                  <circle
                    cx="10"
                    cy="10"
                    r="9.4"
                    stroke="#4A4A4A"
                    strokeWidth="1.2"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

const DeviceSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20">
    <g
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round">
      <g stroke="#0074A8" strokeWidth="1.5">
        <g>
          <g>
            <g>
              <path
                d="M18 2v12.198H2V2h16zm-2.74 15.751H4.74M18 10.531H2"
                transform="translate(-10 -278) translate(0 120) translate(0 144) translate(10 14)"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const IconEquip: React.FC<Props> = ({ className, ...props }) => (
  <Icon
    {...props}
    component={EquipSVG}
    className={cx('icon-equip', className)}
  />
)

export const IconMaintain: React.FC<Props> = ({ className, ...props }) => (
  <Icon
    {...props}
    component={MaintainSVG}
    className={cx('icon-maintain', className)}
  />
)

export const IconMaterial: React.FC<Props> = ({ className, ...props }) => (
  <Icon
    {...props}
    component={MaterialSVG}
    className={cx('icon-material', className)}
  />
)

export const IconReport: React.FC<Props> = ({ className, ...props }) => (
  <Icon
    {...props}
    component={ReportSVG}
    className={cx('icon-report', className)}
  />
)

export const IconSystem: React.FC<Props> = ({ className, ...props }) => (
  <Icon
    {...props}
    component={SystemSVG}
    className={cx('icon-system', className)}
  />
)

export const IconLink: React.FC<Props> = ({ className, ...props }) => (
  <Icon {...props} component={LinkSVG} className={cx('icon-link', className)} />
)

export const IconLocation: React.FC<Props> = ({ className, ...props }) => (
  <Icon
    {...props}
    component={LocationSVG}
    className={cx('icon-location', className)}
  />
)

export const IconEye: React.FC<Props> = ({ className, ...props }) => (
  <Icon {...props} component={EyeSVG} className={cx('icon-eye', className)} />
)

export const IconEdit: React.FC<Props> = ({ className, ...props }) => (
  <Icon {...props} component={EditSVG} className={cx('icon-edit', className)} />
)

export const IconAdd: React.FC<Props> = ({ className, ...props }) => (
  <Icon {...props} component={AddSVG} className={cx('icon-add', className)} />
)

export const IconExport: React.FC<Props> = ({ className, ...props }) => (
  <Icon
    {...props}
    component={ExportSVG}
    className={cx('icon-export', className)}
  />
)

export const IconProcess: React.FC<Props> = ({ className, ...props }) => (
  <Icon
    {...props}
    component={ProcessSVG}
    className={cx('icon-process', className)}
  />
)

export const IconInfo: React.FC<Props> = ({ className, ...props }) => (
  <Icon {...props} component={InfoSVG} className={cx('icon-info', className)} />
)

export const IconHistory: React.FC<Props> = ({ className, ...props }) => (
  <Icon
    {...props}
    component={HistorySVG}
    className={cx('icon-history', className)}
  />
)

export const IconChart: React.FC<Props> = ({ className, ...props }) => (
  <Icon
    {...props}
    component={ChartSVG}
    className={cx('icon-chart', className)}
  />
)

export const IconLight: React.FC<Props> = ({ className, ...props }) => (
  <Icon
    {...props}
    component={LightSVG}
    className={cx('icon-light', className)}
  />
)

export const IconLoading: React.FC<Props> = ({ className, ...props }) => (
  <Icon
    {...props}
    type="loading-3-quarters"
    spin
    className={cx('icon-loading', className)}
  />
)

export const IconHome: React.FC<Props> = ({ className, ...props }) => (
  <Icon
    {...props}
    component={DashboardSVG}
    className={cx('icon-dashboard', className)}
  />
)

export const IconCheck: React.FC<Props> = ({ className, ...props }) => (
  <Icon
    {...props}
    component={CheckSVG}
    className={cx('icon-checks', className)}
  />
)

export const IconUser: React.FC<Props> = ({ className, ...props }) => (
  <Icon {...props} component={UserSVG} className={cx('icon-user', className)} />
)

export const IconSetting: React.FC<Props> = ({ className, ...props }) => (
  <Icon
    {...props}
    component={SettingSVG}
    className={cx('icon-settin', className)}
  />
)

export const IconListAlt: React.FC<Props> = ({ className, ...props }) => (
  <Icon
    {...props}
    component={ListAltSVG}
    className={cx('icon-list-alt', className)}
  />
)

export const IconPlay: React.FC<Props> = ({ className, ...props }) => (
  <Icon {...props} component={PlaySVG} className={cx('icon-play', className)} />
)

export const IconDevice: React.FC<Props> = ({ className, ...props }) => (
  <Icon
    {...props}
    component={DeviceSVG}
    className={cx('icon-equipment', className)}
  />
)
